<template lang="pug">
  span
    button.btn.btn-default(:disabled="disabled",
      type="button",
      @click="checkedIds.length ? modalEditCard.isOpen = true : modalNoItem = true",
      title="更新",
      data-testid="btn-func-edit"): i.fa.fa-pencil

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    portal(to="modal")
      //- 未選択
      app-modal(v-model="modalNoItem" type="info")
        template(slot="title") 未選択
        h4 名刺を1件以上選択してください。

      form(@submit.prevent="submit")
        app-modal(v-model="modalEditCard.isOpen", size="xlarge", data-testid="modal-func-edit-card")
          template(slot="title") 名刺情報の更新

          .row
            .col-xs-11.col-xs-offset-1
              .callout.callout-info.bcard-callout
                h4 更新する項目に更新内容を入力して、チェックボックスにチェックしてください。
                p.text-danger
                  | ※ チェックしていない項目は、最新名刺の情報を引き継いで更新されます。
                  br
                  | ※ チェックした項目が未入力の場合、その項目は未入力で更新されます。
                  br
                  | ※ 修正サービス依頼中の名刺は、修正完了後に名刺情報が上書きされます。

              //.form-group
                //label
                .radio.radio-rich
                  label.radio-inline(data-testid="-radio-target-off")
                    input(type="radio" v-model="isNew" :value="false")
                    span: i.fa.fa-dot-circle-o.fa-lg
                    |
                    |
                    | 既存の最新名刺を修正する
                  label.radio-inline(data-testid="-radio-target-on")
                    input(type="radio" v-model="isNew" :value="true")
                    span: i.fa.fa-dot-circle-o.fa-lg
                    |
                    |
                    | 新規名刺を追加する

          .row
            .col-xs-5.col-xs-offset-1.form-group
              label 情報更新日（名刺交換日）
                span.bcard-required (*)
              date-picker.form-control(
                v-model="exchangeDate",
                name="exchange_date",
                maxdate="0",
                defaultDate="today",
                :required="true")

          hr

          .row
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.last_name" :maxlength="maxlengths.last_name" :is-bulk-edit="true")
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.first_name" :maxlength="maxlengths.first_name" :is-bulk-edit="true")
          .row
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.last_kana" :maxlength="maxlengths.last_kana" :is-bulk-edit="true")
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.first_kana" :maxlength="maxlengths.first_kana" :is-bulk-edit="true")
          .row
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.corporate_name" :maxlength="maxlengths.corporate_name" :is-bulk-edit="true")
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.corporate_kana" :maxlength="maxlengths.corporate_kana" :is-bulk-edit="true")
          .row
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.company_name" :maxlength="maxlengths.company_name" :is-bulk-edit="true")
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.company_kana" :maxlength="maxlengths.company_kana" :is-bulk-edit="true")
          .row
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.dept" :maxlength="maxlengths.dept" :is-bulk-edit="true")
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.post" :maxlength="maxlengths.post" :is-bulk-edit="true")
          .row
            .col-xs-5.col-xs-offset-1
              card-field(v-model="data.dept_post" :maxlength="maxlengths.dept_post" :is-bulk-edit="true")

          hr

          .row
            card-form-office(office-no="1" v-model="dataO1" :maxlengths="maxlengths" :is-bulk-edit="true")
            card-form-office(office-no="2" v-model="dataO2" :maxlengths="maxlengths" :is-bulk-edit="true")

          template(slot="footer" slot-scope="{close}")
            button.btn.btn-primary(type="submit", :disabled="modalEditCard.hasError", data-testid="btn-update") 更新
            button.btn.btn-default(type="button" @click.prevent="close", data-testid="btn-cancel") キャンセル

      app-modal(v-model="modalError" type="warning")
        template(slot="title") エラー
        h4 名刺情報の更新に失敗しました。
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-default(type="button" @click="close()") 閉じる
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import DatePicker from '@/components/molecules/DatePicker'
import CardField from '@/components/molecules/CardField'
import CardFormOffice from '@/components/organisms/forms/CardFormOffice'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const BcardRepository = RepositoryFactory.get('bcard')

/**
 * dataの中から、checkedがtrueになっているものを、valueだけ抜き出す
 * @ {object} data
 */
const filterObject = (data) => {
  return Object.keys(data).reduce(
    /**
     * @param {object} acc ループ中に作りかけているオブジェクト
     * @param {string} field 現在のキー
     * @returns {{}}
     */
    (acc, field) => {
      return data[field]['checked'] === true
        ? {
          ...acc,
          [field]: data[field]['value']
        }
        : acc
    }, {}) // reduce初期値
}

const initData = {
  last_name: {
    label: '姓',
    field: 'last_name',
    value: '',
    checked: false
  },
  first_name: {
    label: '名',
    field: 'first_name',
    value: '',
    checked: false
  },
  last_kana: {
    label: '姓（よみがな）',
    field: 'last_kana',
    value: '',
    checked: false
  },
  first_kana: {
    label: '名（よみがな）',
    field: 'first_kana',
    value: '',
    checked: false
  },
  corporate_name: {
    label: '会社名',
    field: 'corporate_name',
    value: '',
    checked: false
  },
  corporate_kana: {
    label: '会社名（よみがな）',
    field: 'corporate_kana',
    value: '',
    checked: false
  },
  company_name: {
    label: 'カンパニー名',
    field: 'company_name',
    value: '',
    checked: false
  },
  company_kana: {
    label: 'カンパニー名（よみがな）',
    field: 'company_kana',
    value: '',
    checked: false
  },
  dept: {
    label: '部署名',
    field: 'dept',
    value: '',
    checked: false
  },
  post: {
    label: '役職',
    field: 'post',
    value: '',
    checked: false
  },
  dept_post: {
    label: '部署名＋役職',
    field: 'dept_post',
    value: '',
    checked: false
  },
  o1_office_name: {
    label: '事業所名',
    field: 'o1_office_name',
    value: '',
    checked: false
  },
  o1_zipcode: {
    label: '郵便番号',
    field: 'o1_zipcode',
    value: '',
    checked: false
  },
  o1_address1: {
    label: '住所1',
    field: 'o1_address1',
    value: '',
    checked: false
  },
  o1_address2: {
    label: '住所2',
    field: 'o1_address2',
    value: '',
    checked: false
  },
  o1_tel1: {
    label: '電話番号1',
    field: 'o1_tel1',
    value: '',
    checked: false
  },
  o1_naisen1: {
    label: '電話番号1内線',
    field: 'o1_naisen1',
    value: '',
    checked: false
  },
  o1_tel2: {
    label: '電話番号2',
    field: 'o1_tel2',
    value: '',
    checked: false
  },
  o1_naisen2: {
    label: '電話番号2内線',
    field: 'o1_naisen2',
    value: '',
    checked: false
  },
  o1_mobile: {
    label: '携帯電話',
    field: 'o1_mobile',
    value: '',
    checked: false
  },
  o1_fax: {
    label: 'FAX',
    field: 'o1_fax',
    value: '',
    checked: false
  },
  o1_mail: {
    label: 'メールアドレス',
    field: 'o1_mail',
    value: '',
    checked: false
  },
  o1_url: {
    label: 'URL',
    field: 'o1_url',
    value: '',
    checked: false
  },
  o2_office_name: {
    label: '事業所名',
    field: 'o2_office_name',
    value: '',
    checked: false
  },
  o2_zipcode: {
    label: '郵便番号',
    field: 'o2_zipcode',
    value: '',
    checked: false
  },
  o2_address1: {
    label: '住所1',
    field: 'o2_address1',
    value: '',
    checked: false
  },
  o2_address2: {
    label: '住所2',
    field: 'o2_address2',
    value: '',
    checked: false
  },
  o2_tel1: {
    label: '電話番号1',
    field: 'o2_tel1',
    value: '',
    checked: false
  },
  o2_naisen1: {
    label: '電話番号1内線',
    field: 'o2_naisen1',
    value: '',
    checked: false
  },
  o2_tel2: {
    label: '電話番号2',
    field: 'o2_tel2',
    value: '',
    checked: false
  },
  o2_naisen2: {
    label: '電話番号2内線',
    field: 'o2_naisen2',
    value: '',
    checked: false
  },
  o2_mobile: {
    label: '携帯電話',
    field: 'o2_mobile',
    value: '',
    checked: false
  },
  o2_fax: {
    label: 'FAX',
    field: 'o2_fax',
    value: '',
    checked: false
  },
  o2_mail: {
    label: 'メールアドレス',
    field: 'o2_mail',
    value: '',
    checked: false
  },
  o2_url: {
    label: 'URL',
    field: 'o2_url',
    value: '',
    checked: false
  }
}

export default {
  name: 'FuncEditCard',
  components: { AppModal, AppMessages, DatePicker, CardFormOffice, CardField },
  props: {
    checkedIds: { type: Array, required: false, default: function () { return [] } }
  },
  data () {
    return {
      modalNoItem: false,
      modalEditCard: {
        isOpen: false, // 名刺更新ダイアログの開閉状況
        initialized: true, // 名刺更新情報が読み込み完了しているかどうか
        hasError: false, // エラーが発生したかどうか
        value: {} // 名刺更新ダイアログの更新内容
      },
      modalError: false,

      isNew: false, // 新規名刺を追加するかどうか

      exchangeDate: '',

      data: {},
      dataO1: {},
      dataO2: {}
    }
  },
  computed: {
    disabled () {
      // 全ページ選択モードの時は利用しない
      return this.$parent.isAllPagesChecked
    }
  },
  watch: {
    'modalEditCard.isOpen' (isOpen) {
      if (isOpen) {
        this.initData()
      }
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('Bcards')
  },
  methods: {
    // 表示するたびに入力値をリセットする
    initData () {
      this.exchangeDate = null

      this.data = {}
      this.dataO1 = {}
      this.dataO2 = {}
      for (let field in initData) {
        let target = ''
        if (field.indexOf('o1_') === 0) {
          target = 'dataO1'
        }
        else if (field.indexOf('o2_') === 0) {
          target = 'dataO2'
        }
        else {
          target = 'data'
        }
        this[target][field] = Object.assign({}, initData[field]) // 参照コピーではなく値コピー
      }
    },
    submit () {
      // APIに送信するデータ
      const sidBcards = this.checkedIds
      const exchangeDate = this.exchangeDate

      let bcard = {}
      Object.assign(bcard, filterObject(this.data))
      Object.assign(bcard, filterObject(this.dataO1))
      Object.assign(bcard, filterObject(this.dataO2))

      if (Object.keys(bcard).length === 0) {
        this.showToast('更新する項目を1つ以上、選択してください。', { type: 'danger' })
        return
      }

      const vm = this
      BcardRepository.buldPost(sidBcards, exchangeDate, bcard, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.showToast('名刺情報を変更しました。', { type: 'success' })
            vm.$store.dispatch('reloadBcardList')
            vm.modalEditCard.isOpen = false
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺情報を変更できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
  // パンくず＞会社情報の一括更新（更新確認モード時）
  .breadcrumb-edit {
    cursor: pointer;
  }

  // 更新対象項目＞チェックボックス
  .form-group {
    .checkbox-rich {
      position: absolute;
      margin-top: 0;
      z-index: 1;
    }

    &.col-xs-12 {
      .checkbox-rich {
        margin-left: -8.33333%;
      }
    }

    &.col-sm-6 {
      .checkbox-rich {
        margin-left: -16.66666%;

        @media (max-width: $screen-xs-max) {
          margin-left: -8.33333%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncEditCard.vue